import type { LoadingSize } from './Loading';

export const useLoadingSize = (size: LoadingSize) => {
  let loadingSize: number;

  if (size === 'small') {
    loadingSize = 16;
  } else if (size === 'medium') {
    loadingSize = 32;
  } else if (size === 'large') {
    loadingSize = 64;
  } else {
    loadingSize = 16;
  }

  return loadingSize;
};
